import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../build/loaders/fix-light-dark.js!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[3]!./server.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-flex;
  vertical-align: middle;
}

.button {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/button/element.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd","sourcesContent":["@import url(\"./server.css\");\n\n:host {\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.button {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
